

















































import { Component } from 'vue-property-decorator';

import { Gradient } from '@/components/wobble/model';
import AnimatedTextIteration from '@/components/AnimatedTextIteration.vue';
import Chapter from './Chapter.vue';
import FloatingWobble from '@/components/wobble/FloatingWobble.vue';

@Component({
  components: {
    FloatingWobble,
    AnimatedTextIteration,
  }
})
export default class MoreSenses extends Chapter {
  public wobbleGradient = new Gradient(
    '#00f192',
    '#22dde7',
    0.0,
    1.0,
    60.39,
    249.79,
    448.21,
    249.79,
  );

  public suggestions = [
    'your clothes<br>on your body?',
    'your posture?',
    'points of contact<br>with your surroundings?',
  ];

  chapterActivated() {
    this.lockScroll();
  }

  public proceedToNextChapter() {
    this.releaseScroll();
    this.goToNextChapter();
  }
}
